import { PreloadedQuery } from 'react-relay';

import { ContentTabName } from '@townsquare/content-tabs/types';
import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';
import { fg } from '@townsquare/stat-sig/gate';

import ProjectUpdatesQuery, {
	type ProjectUpdatesQuery as ProjectUpdatesQueryType,
} from '../components/ProjectUpdatesTab/__generated__/ProjectUpdatesQuery.graphql';
import ProjectViewQuery, {
	type ProjectViewQuery as ProjectViewQueryType,
} from '../components/__generated__/ProjectViewQuery.graphql';

export const projectViewResource: RouteResource<
	PreloadedQuery<ProjectViewQueryType, Record<string, unknown>>
> = createRelayResource<ProjectViewQueryType>({
	getQuery: (routerContext) => {
		return {
			query: ProjectViewQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
				trackViewEvent: 'DIRECT',
				includeDraftUpdate: fg('townsquare-ai-updates-drafts-on-agg'),
			},
		};
	},
});

export const projectUpdatesResource: RouteResource<
	PreloadedQuery<ProjectUpdatesQueryType, Record<string, unknown>>
> = createRelayResource<ProjectUpdatesQueryType>({
	getQuery: (routerContext) => {
		const tabName = routerContext.match.params.tabName;
		const isUpdatesTab = tabName === ContentTabName.UPDATES;

		return {
			query: ProjectUpdatesQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
				trackViewEvent: 'DIRECT',
				isUpdatesTab,
			},
		};
	},
});
